<a mat-raised-button [routerLink]="[]" [fragment]="'content'" class="skipToContent">{{ "COMPONENTS.EVERYWHERE.SKIPCONTENTBUTTON" | translate }}</a>
@if (menuOpen) {
  <app-menu (requestclose)="menuOpen = false" #menuComponent [items]="menu" animate.enter="menu-enter" animate.leave="menu-leave"></app-menu>
}
<app-global-loading></app-global-loading>
@if (!applicationService.initialized) {
  {{ "COMPONENTS.EVERYWHERE.LOADING" | translate }}...
} @else {
  <div id="application" class="w-100 d-flex flex-column">
    <app-header #header (openMenu)="menuOpen = true" class="sticky-top container-fluid"></app-header>
    @if (initialized) {
      <div
        id="content"
        tabindex="0"
        class="container flex-grow-1"
        [ngClass]="{
          blocking: applicationService.blocked,
        }"
      >
        <div id="alertContainer d-flex h-auto align-items-start">
          <div>
            <!-- TODO: -->
            <!-- @if (applicationService.session.user?.status === "PendingDeleted") {
              <div class="message warning">
                <p>{{ "COMPONENTS.EVERYWHERE.WARNING_ACCOUNT_DISABLED" | translate }}</p>
              </div>
            } -->
            <!-- @if (applicationService.session.user?.incomplete() && applicationService.session.activeRole.name === "resident") {
              <div class="message warning">
                <p>
                  {{ "COMPONENTS.EVERYWHERE.WARNING_INCOMPLETE_ACCOUNT_START" | translate }}
                  <a class="href" routerLink="/content/profile">{{ "COMPONENTS.EVERYWHERE.WARNING_INCOMPLETE_ACCOUNT_OPEN" | translate }}</a>
                  {{ "COMPONENTS.EVERYWHERE.WARNING_INCOMPLETE_ACCOUNT_END" | translate }}
                </p>
              </div>
            } -->
          </div>
        </div>
        <div class="row w-100 m-0">
          <router-outlet (activate)="applicationService.setLoading(false)" (deactivate)="applicationService.setLoading(true)"></router-outlet>
        </div>
      </div>
    }
    <app-footer #footer></app-footer>
  </div>
}

<ng-template #warningHTMLDialog let-data="data">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md" [innerHTML]="data.text | translate"></div>
    </div>
  </div>
</ng-template>
